document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    // Preloader animation with existence check
    const preloader = document.querySelector(".preloader");
    const header = document.querySelector(".header");
    const logoItem = document.querySelector(".logo-item");

    let tl = gsap.timeline();

    if (preloader) {
        tl.to(".preloader", {
            y: "-100%",
            borderRadius: "10% 10% 36% 39% / 10% 10% 55% 56%",
            duration: 1,
            ease: "power2.out"
        }).add(() => {
            preloader.style.display = "none";
        });
    }

    // Header animation
    if (header) {
        tl.from(".header", {
            duration: 1,
            y: "-100%"
        });
    }

    // Logo animation
    if (logoItem) {
        tl.from(".logo-item", {
            y: 30,
            opacity: 0,
            duration: 0.6,
            ease: "power2.out"
        });
    }

    // Banner text animation with existence check
    const commerceTitle = document.querySelector(".commerce-title span");
    const commerceSection = document.querySelector(".commerce-section");

    if (commerceTitle && commerceSection) {
        gsap.from(".commerce-title span", {
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".commerce-section",
                start: "top 70%",
                toggleActions: "play none none none"
            }
        });
    }



    document.querySelectorAll(".tabslider-project-title").forEach(title => {
        gsap.from(title, {
            y: 50,
            opacity: 0,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
                trigger: ".tabslider-main",
                start: "top 85%",
                toggleActions: "play none none none"
            }
        });
    });




  // Animate each logo item when it enters the viewport
  gsap.utils.toArray(".commerce-section .logo-items").forEach((item) => {
    gsap.fromTo(item,
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: item,
          start: "top 80%", // when item enters the viewport
          toggleActions: "play none none none",
        },
      }
    );
  });
    


    // blog banners
    const banners = document.querySelectorAll(".banner-article");

    banners.forEach((banner) => {
        const titleMain = banner.querySelector(".title-main");
        const titleSub = banner.querySelector(".title-sub");
        const date = banner.querySelector(".article-date");
        const link = banner.querySelector(".read-more");

        gsap.from([date, titleMain, titleSub, link], {
            y: 80,
            opacity: 0,
            duration: 1.2,
            ease: "power4.out",
            stagger: 0.2,
            scrollTrigger: {
                trigger: banner, // this ensures it fires individually for each
                start: "top 20%",
                toggleActions: "play none none none",
                markers: false, // set to true to debug
            },
        });
    });

    // Projects-section title text with existence check
    const heroTitle = document.querySelector(".hero-title span");
    const heroContentWrapper = document.querySelector(".hero-content-wrapper");

    if (heroTitle && heroContentWrapper) {
        gsap.from(".hero-title span", {
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".hero-content-wrapper",
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
    }

    // Animate logo with existence check
    const heroLogo = document.querySelector(".hero-logo img");

    if (heroLogo && heroContentWrapper) {
        gsap.from(".hero-logo img", {
            opacity: 0,
            scale: 0.85,
            duration: 1,
            ease: "back.out(1.7)",
            scrollTrigger: {
                trigger: ".hero-content-wrapper",
                start: "top 50%",
                toggleActions: "play none none none"
            }
        });
    }

    gsap.utils.toArray(".project-card").forEach((card, i) => {
        gsap.from(card, {
            opacity: 0,
            y: 50,
            scale: 0.95,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
                trigger: card,
                start: "top 85%",
                toggleActions: "play none none none", // reverse on scroll-up
                // markers: true, // enable to debug
            }
        });
    });

    // Newsletter animation with existence check
    const newsletter = document.querySelector(".newsletter");
    
    if (newsletter) {
        gsap.from(".newsletter .footer-block__heading,.newsletter .footer-block__subheading", {
            y: 50,
            opacity: 0,
            duration: 1.2,
            ease: "power3.out",
            scrollTrigger: {
                trigger: ".newsletter",
                start: "top 70%",
                toggleActions: "play none none none",
                markers: false,
            },
        });
    }

    // Footer logo animation with existence check
    const footerLogo = document.querySelector(".footer-logo");
    
    if (footerLogo) {
        gsap.from(".footer-logo", {
            y: 50,
            opacity: 0,
            duration: 1.2,
            ease: "circ.out",
            scrollTrigger: {
                trigger: ".footer-logo",
                start: "top 70%",
                toggleActions: "play none none none",
                markers: false,
            },
        });
    }





    // rotating text    
    const scrollingText = document.querySelector("#scrollingText");

    if (scrollingText) {
        // Infinite scrolling animation
        gsap.to(scrollingText, {
            x: 1000,
            duration: 50,
            repeat: -1,
            ease: "linear"
        });

        // Scroll-triggered class toggle
        gsap.to(scrollingText, {
            xPercent: 15,
            scrollTrigger: {
                trigger: scrollingText,
                start: "top 70%",
                end: "bottom 10%",
                scrub: 1,
                onEnter: () => {
                    document.body.classList.add("lite-theme");
                },
                onEnterBack: () => {
                    document.body.classList.add("lite-theme");
                },
                onLeave: () => {
                    document.body.classList.remove("lite-theme");
                },
                onLeaveBack: () => {
                    document.body.classList.remove("lite-theme");
                }
            }
        });
    }




    // Overlay text animation with existence check
    const overlayTextH2 = document.querySelector(".overlay-text h2");
    
    if (overlayTextH2) {
        gsap.from(".overlay-text h2", {
            y: 50,
            opacity: 0,
            duration: 1.2,
            ease: "power4.out",
            stagger: 0.3,
        });
    }

    // Background images animation with existence check
    const bgImages = document.querySelectorAll(".bg-image");
    const heroSection = document.querySelector(".hero-section");

    if (bgImages.length > 0) {
        gsap.from(".bg-image", {
            scale: 1.2,
            opacity: 0,
            duration: 1.5,
            ease: "power3.out",
            stagger: 0.2,
        });

        // Parallax on scroll
        if (heroSection) {
            bgImages.forEach((el, i) => {
                gsap.to(el, {
                    y: i === 1 ? -50 : -100,
                    scrollTrigger: {
                        trigger: ".hero-section",
                        start: "top top",
                        end: "bottom top",
                        scrub: true,
                    }
                });
            });
        }
    }


    // Strategy steps animation with existence check
    const strategyStepsH2 = document.querySelector(".strategy-steps h2");
    const strategyStepsMain = document.querySelector(".strategy_steps_main");

    if (strategyStepsH2 && strategyStepsMain) {
        gsap.from(".strategy-steps h2", {
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".strategy_steps_main",
                start: "top 70%",
                toggleActions: "play none none none"
            }
        });
    }
    // Simple article animations with existence check
    const simpleArticleH2 = document.querySelector(".simple-article .article-content h2");
    const simpleArticlesMain = document.querySelector(".simple-articles-main");
    const strategyGrid = document.querySelector(".simple-article .article-content .strategy-grid");

    if (simpleArticleH2 && simpleArticlesMain) {
        gsap.from(".simple-article .article-content h2", {
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".simple-articles-main",
                start: "top 70%",
                toggleActions: "play none none none"
            }
        });
    }

    if (strategyGrid && simpleArticlesMain) {
        gsap.from(".simple-article .article-content .strategy-grid", {
            opacity: 0,
            y: 40,
            duration: 0.8,
            ease: "power2.out",
            stagger: 0.2,
            scrollTrigger: {
                trigger: ".simple-articles-main",
                start: "top 50%",
                toggleActions: "play none none none"
            }
        });
    }


    // document.querySelectorAll(".strategy-item").forEach((item, i) => {
    //     gsap.from(item, {
    //         opacity: 0,
    //         y: 100,
    //         duration: 1,
    //         ease: "power4.out",
    //         scrollTrigger: {
    //             trigger: item,
    //             start: "top 85%",
    //             toggleActions: "play none none none", // or use 'restart none none reset' for testing
    //         },
    //         delay: i * 0.1, // stagger effect
    //     });
    //     gsap.from(item, {
    //         x: i % 2 === 0 ? -100 : 100,
    //         opacity: 0,
    //         scale: 0.9,
    //         duration: 1.2,
    //         ease: "expo.out",
    //         scrollTrigger: {
    //             trigger: item,
    //             start: "top 90%",
    //             toggleActions: "play none none none",
    //         },
    //     });
    // });



    // Career hero animations with existence check
    const careerHeroText = document.querySelector(".career-hero-text");
    const careerHero = document.querySelector(".career-hero");
    const careerHeroImage = document.querySelector(".career-hero-image img");

    if (careerHeroText && careerHero) {
        gsap.from(".career-hero-text", {
            x: -100,
            opacity: 0,
            duration: 1.2,
            ease: "power4.out",
            scrollTrigger: {
                trigger: ".career-hero",
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
    }

    if (careerHeroImage && careerHero) {
        gsap.from(".career-hero-image img", {
            x: 100,
            opacity: 0,
            duration: 1.2,
            ease: "power4.out",
            scrollTrigger: {
                trigger: ".career-hero",
                start: "top 80%",
                toggleActions: "play none none none"
            }
        });
    }


    // Box animation with existence check
    const box = document.querySelector(".box");
    const mySection = document.querySelector("#my-section");

    if (box && mySection) {
        gsap.to(".box", {
            x: 300,
            duration: 2,
            scrollTrigger: {
                trigger: "#my-section",
                start: "top 80%",
                end: "bottom 20%",
                scrub: true
            }
        });
    }


});





$(document).ready(function () {

    document.querySelectorAll(".slide").forEach(slide => {
        gsap.from(slide.querySelectorAll(".slide-text, .slide-image"), {
            y: 50,
            opacity: 0,
            duration: 1,
            stagger: 0.2,
            ease: "power3.out",
            scrollTrigger: {
                trigger: slide,
                start: "top 80%", // when slide reaches 80% of viewport
                toggleActions: "play none none none"
            }
        });
    });
    $('.slider').slick({
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
    });
});


$(document).ready(function() {
  
  if ($(window).width() < 1024) {

  // Toggle on header click
  $('.toogle-footer h5').on('click', function() {
    var $footerBlock = $(this).closest('.toogle-footer');
    $footerBlock.toggleClass('active');
    $footerBlock.find('.mobile-toggle').slideToggle();
  });
  }


  
});

$(document).ready(function() {
  var $popup = $('.DP__career-form-text');

  // Create and append overlay dynamically if not present
  if ($('#popup-overlay').length === 0) {
    var $overlay = $('<div id="popup-overlay"></div>');
    $('body').append($overlay);
    $overlay.append($popup);
  }

  var $overlay = $('#popup-overlay');

  // Initially hide everything
  $overlay.hide();
  $popup.hide();

  $('.popup-trigger').on('click', function(e) {
    e.preventDefault();

    if ($('#popup-close').length === 0) {
      var closeBtn = $('<span id="popup-close" style="position:absolute;top:10px;right:10px;cursor:pointer;font-size: 50px;font-weight: normal;line-height: 20px;">&times;</span>');
      $popup.append(closeBtn);
    }

    $overlay.fadeIn();
    $popup.fadeIn().addClass('show-popup');

    // --- GSAP Animation Example ---
    // Make sure GSAP and ScrollTrigger are loaded
    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);

      // Optional: kill previous triggers to avoid duplicates
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());

      // Example animation for an element inside the popup
      gsap.fromTo(
        ".popup-animate", // Add this class to the element you want to animate
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: ".popup-animate",
            scroller: ".DP__career-form-text", // If your popup is scrollable
            start: "top 80%",
            end: "bottom 20%",
            scrub: true
          }
        }
      );

      // Refresh ScrollTrigger after popup is visible
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
    }
  });

  $overlay.on('click', '#popup-close', function() {
    $popup.fadeOut().removeClass('show-popup');
    $('#popup-close').remove();
    $overlay.fadeOut();

    // Optional: kill triggers when popup closes
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }
  });
});
